<template>
  <div class="after_sales_apply">
    <!--售后申请顶部-->
    <div v-if="orderMsg" class="after_sales_apply_top">
      <div class="after_sales_apply_top_left mb20">
        <div>
          <span><i>*</i>系统订单号：</span>
          <div class="w_percent38 mr5">
            <input type="text" title="系统订单号" maxlength="30" v-model.trim="systemOrderNum" @blur="getOrderData()" @keyup.enter="getOrderData()">
            <!--D190318111109620491-->
          </div>
          <i v-if="orderMsg.OrderRefundRelationList">注意：该订单已经申请过至少一次售后</i>
        </div>
        <div>
          <span>平台订单号：</span>
          <div class="w_percent38 mr5"><input type="text" title="平台订单号" v-model="orderMsg.OutOrderId" disabled></div>
        </div>
        <div>
          <span><i>*</i>售后类型：</span>
          <div>
            <el-select v-model="selectAfterSalesType" placeholder="售后类型">
              <el-option v-for="item in afterSalesTypeList"
                         :key="item.id"
                         :label="item.text"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <span><i>*</i>售后原因：</span>
          <div>
            <el-select v-model="selectAfterSalesReason" placeholder="售后原因">
              <el-option v-for="item in afterSalesReasonList"
                         :key="item.id"
                         :label="item.text"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <span>发出仓库：</span>
          <div>
            <input type="text" title="发出仓库" v-model="orderMsg.StoreroomName" disabled>
           <!-- <el-select v-model="selectWarehouse" placeholder="受理仓库">
              <el-option v-for="item in warehouseList"
                         :key="item.id"
                         :label="item.text"
                         :value="item.id">
              </el-option>
            </el-select> -->
          </div>
        </div>
       <!-- <div v-if="selectAfterSalesType === 3 || selectAfterSalesType === 4 || selectAfterSalesType === 5">
          <span>退货物流：</span>
          <div>
            <el-select v-model="selectCourierCompany" placeholder="快递公司">
              <el-option v-for="item in courierCompanyList"
                         :key="item.id"
                         :label="item.text"
                         :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="selectAfterSalesType === 3 || selectAfterSalesType === 4 || selectAfterSalesType === 5">
          <span>物流单号：</span>
          <div class="w_percent38 mr5"><input type="text" title="物流单号" v-model.trim="logisticsNumber"></div>
        </div> -->
        <div class="after_sales_message">
          <span>售后留言：</span>
          <div class="w_percent70 h150 mr5"><textarea class="w_percent95 h_percent83" maxlength="200" placeholder="输入框限制最多只能输入200个字符。" v-model.trim="orderRemark"></textarea></div>
          <!--<i>注：订单在平台下单运费：12.00元</i>-->
        </div>

      </div>
      <div class="after_sales_apply_top_right">
        <div class="text_center">提示说明</div>
        <div>
          <p>1.订单申请售后，售后单状态未变成售后成功前，订单将拒绝进行订单的：激活、审单、拆单、合单、批量付款、全部付款、批量配货、全部配货等操作，如果订单状态为待发货，系统不会拦截渠道进行发货操作；</p>
          <p>2.订单未发货前，只允许创建“取消订单”和“仅退款”类型的售后；</p>
          <p>3.订单已发货的，只允许申请“退货”、“换货”、“漏发”类型的售后；</p>
          <p>4.“退货”、“换货”、“漏发”类型的售后，申请时必须至少选择一个售后明细；</p>
          <p>5.如果退换货类型售后，买家退回的商品为错发的货品，请选择售后明细时勾选错发，并填写上错发的货号和尺码，方便渠道收货时可以核对售后明细和收货明细是否一致。渠道反馈实际收货信息与售后明细无法一致对应的，平台将自动拒绝售后。</p>
          <p>6.关于处于待发货状态的订单，售后做受理前务必联系渠道是否已发货，已发货的让渠道反馈发货信息后再根据实际处理售后；如果未发货，让渠道将订单撤回后再根据实际处理售后；</p>
          <p>7."取消订单”和“仅退款”类型的售后单只处理分销商与买家之间的问题，渠道不介入，平台也不会产生退款给分销商的处理，如果分销商需要针对订单需要向渠道申请补偿的，请直接走申诉工单流程处理。</p>
        </div>
      </div>
    </div>
    <!--售后申请列表-->
    <div class="after_sales_apply_msg">
      <table v-if="selectAfterSalesType !== 1 && selectAfterSalesType !== 2" class="table tb_border">
        <thead>
        <tr>
          <th></th>
          <th>品名</th>
          <th>货号</th>
          <th>尺码</th>
          <th>数量</th>
          <th>市场价</th>
          <th>成交单价</th>
          <th>优惠金额</th>
          <th>合计</th>
          <th>拿货单价</th>
          <th>拿货单价合计</th>
          <th>错发货号</th>
          <th>错发尺码</th>
          <th>错发？</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="orderMsg" v-for="(item, index) in orderMsg.OrderDetailList" :key="index">
          <td><i class="iconfont icon-del fcDel" @click="ctrlBtn('del', index)"></i></td>
          <td>{{item.GoodsName}}</td>
          <td>{{item.GoodsId}}</td>
          <td>{{item.SizeName}}</td>
          <td><input class="w40" type="number" title="实发数量" min="1" step="1" v-model.number="item.SendQuantity" @input="changeQuantity(index)"></td>
          <td>{{item.MarkPrice}}</td>
          <td>{{item.UnitPrice}}</td>
          <td><input class="w60" type="text" title="优惠金额" v-model.number="item.OfferFee" @input="changeQuantity(index)"></td>
          <td>{{item.clinchADealUnitpriceRow}}</td>
          <td>{{item.AgentCostPrice}}</td>
          <td>{{item.takeAUnitPriceOfGoodsRow}}</td>
          <td><input class="w60" type="text" title="错发货号" v-model.trim="item.errorGoodsNum"></td>
          <td><input class="w60" type="text" title="错发尺码" v-model.trim="item.errorSize"></td>
          <td><input type="checkbox" title="错发" v-model="item.isError"></td>
        </tr>
        <tr>
          <td colspan="7" class="fcBlue">注意：以上是您需要退、换或漏发的货品，请慎重选择！如果选择错发，收货时系统以错发货品进行收货验证！</td>
          <td>合计</td>
          <td>{{orderMsg.clinchADealUnitpriceCol}}</td>
          <td></td>
          <td>{{orderMsg.takeAUnitPriceOfGoodsCol}}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div class="text_center mt30 mb20">
        <!--<button class="btn_normal mr40" @click="ctrlBtn('checkOrderNum', 1)">提交</button>-->
        <!--<button class="btn_normal mr40" @click="checkExpressNumIsUsed()">提交</button>-->
        <button class="btn_normal mr40" @click="saveRefundInfo()">提交</button>
        <button class="btn_cancel" @click="getOrderData()">重置</button>
      </div>
    </div>

    <!--弹出框-->
    <after-sales-apply-embed-msg v-if="isShow"
                                 :title="dialogTitle"
                                 :showType="dialogShowType"
                                 :orderMsg="orderMsgParams"
                                 @cancelbtn="getSelectDialogEmbed"></after-sales-apply-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import AfterSalesApplyEmbedMsg from './after-sales-apply-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'after-sales-apply',
    components: {AfterSalesApplyEmbedMsg, LoadingDialog, MsgDialog},
    computed: {
      refundCountInfo: {
        get: function () {
          return this.$store.state.refundCountInfo;
        },
        set: function (newVal) {
          this.$store.state.refundCountInfo = newVal;
          return this.$store.state.refundCountInfo;
        }
      }
    },
    data() {
      return {
        orderMsgParams: null, // 订单提交参数
        systemOrderNum: '', // 系统订单号
        orderMsg: {
          OutOrderId: '', // 外部/平台订单号
          OrderRefundRelationList: null, // 判断是否售后过
          OrderDetailList: [] // 商品明细列表
        }, // 订单信息
        afterSalesTypeList: [], // 售后类型列表
        selectAfterSalesType: '', // 选择的售后类型
        afterSalesReasonList: [], // 售后原因列表
        selectAfterSalesReason: '', // 选择的售后原因
        warehouseList: [], // 仓库列表
        selectWarehouse: '', // 选择的仓库
        courierCompanyList: [], // 快递公司下拉
        selectCourierCompany: '', // 选择的快递公司
        logisticsNumber: null, // 物流单号
        orderRemark: null, // 留言
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      // 获取售后类型下拉框数据
      getRefundTypeList() {
        this.$axios.get(this.Global.getRefundTypeList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.afterSalesTypeList = res.data.resData;
            this.afterSalesTypeList.splice(0, 0, {id: '', text: '售后类型'});
            this.selectAfterSalesType = '';
          } else {
            this.afterSalesTypeList = [];
            this.selectAfterSalesType = res.data.errorMsg;
          }
        });
      },

      // 获取售后原因下拉框数据
      getRefundReasonList() {
        this.$axios.get(this.Global.getRefundReasonList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.afterSalesReasonList = res.data.resData;
            this.afterSalesReasonList.splice(0, 0, {id: '', text: '售后原因'});
            this.selectAfterSalesReason = '';
          } else {
            this.afterSalesReasonList = [];
            this.selectAfterSalesReason = res.data.errorMsg;
          }
        });
      },

      // 获取售后发出仓库（渠道）下拉数据
      getSendOutStoreroomList() {
        this.$axios.get(this.Global.getSendOutStoreroomList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.warehouseList = res.data.resData;
            this.warehouseList.splice(0, 0, {id: '', text: '发出仓库'});
            this.selectWarehouse = '';
          } else {
            this.warehouseList = [];
            this.selectWarehouse = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          console.log(res);
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            this.courierCompanyList.push({id: '', text: '其它'});
            this.selectCourierCompany = '';
          } else {
            this.courierCompanyList = [];
            this.selectCourierCompany = res.data.errorMsg;
          }
        });
      },

      // 根据订单号加载订单数据（包含主单、订单明细、仓库信息、订单售后关系）
      getOrderData() {
        if (this.systemOrderNum) {
          this.$axios.post(this.Global.getOrderData(this.systemOrderNum), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.orderMsg = res.data.resData;
              if (this.orderMsg) {
                this.$set(this.orderMsg, 'clinchADealUnitpriceCol', 0);
                this.$set(this.orderMsg, 'takeAUnitPriceOfGoodsCol', 0);
                let clinchADealUnitpriceCol = 0;
                let takeAUnitPriceOfGoodsCol = 0;
                let orderDetailList = this.orderMsg.OrderDetailList;
                for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
                  this.$set(this.orderMsg.OrderDetailList[i], 'clinchADealUnitpriceRow', 0);
                  this.$set(this.orderMsg.OrderDetailList[i], 'takeAUnitPriceOfGoodsRow', 0);
                  this.$set(this.orderMsg.OrderDetailList[i], 'errorGoodsNum', null);
                  this.$set(this.orderMsg.OrderDetailList[i], 'errorSize', null);
                  this.$set(this.orderMsg.OrderDetailList[i], 'isError', false);
                  this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow = this.Global.subtraction(this.Global.multiplication(orderDetailList[i].SendQuantity, orderDetailList[i].UnitPrice), orderDetailList[i].OfferFee);
                  this.orderMsg.OrderDetailList[i].takeAUnitPriceOfGoodsRow = this.Global.multiplication(orderDetailList[i].SendQuantity, orderDetailList[i].AgentCostPrice);
                  clinchADealUnitpriceCol = this.Global.addition(clinchADealUnitpriceCol, this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
                  takeAUnitPriceOfGoodsCol = this.Global.addition(takeAUnitPriceOfGoodsCol, this.orderMsg.OrderDetailList[i].takeAUnitPriceOfGoodsRow);
                }
                this.orderMsg.clinchADealUnitpriceCol = clinchADealUnitpriceCol;
                this.orderMsg.takeAUnitPriceOfGoodsCol = takeAUnitPriceOfGoodsCol;
              }
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        }
      },

      // 改变数量
      changeQuantity(index) {
        let quantity = this.orderMsg.OrderDetailList[index].SendQuantity;
        if (!parseInt(quantity)) {
          quantity = 0;
        }
        quantity = parseInt(quantity);
        if (this.orderMsg.OrderDetailList[index].Quantity < quantity) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '退货数量不能大于订单明细数量';
          // quantity = this.orderMsg.OrderDetailList[index].Quantity;
          this.orderMsg.OrderDetailList[index].SendQuantity = this.orderMsg.OrderDetailList[index].Quantity;
          return;
        }
        this.orderMsg.OrderDetailList[index].clinchADealUnitpriceRow =
          this.Global.subtraction(this.Global.multiplication(parseInt(quantity), this.orderMsg.OrderDetailList[index].UnitPrice), this.orderMsg.OrderDetailList[index].OfferFee);
        this.orderMsg.OrderDetailList[index].takeAUnitPriceOfGoodsRow = this.Global.multiplication(parseInt(quantity), this.orderMsg.OrderDetailList[index].AgentCostPrice);

        this.orderMsg.clinchADealUnitpriceCol = 0;
        this.orderMsg.takeAUnitPriceOfGoodsCol = 0;
        for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
          // console.log('计算');
          this.orderMsg.clinchADealUnitpriceCol = this.Global.addition(this.orderMsg.clinchADealUnitpriceCol, this.orderMsg.OrderDetailList[i].clinchADealUnitpriceRow);
          this.orderMsg.takeAUnitPriceOfGoodsCol = this.Global.addition(this.orderMsg.takeAUnitPriceOfGoodsCol, this.orderMsg.OrderDetailList[i].takeAUnitPriceOfGoodsRow);
        }
      },

      // 检测退回运单号是否已被其他售后单使用
      checkExpressNumIsUsed() {
        if (!this.selectAfterSalesType) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个售后类型';
          return;
        } else if (!this.selectAfterSalesReason) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个售后原因';
          return;
        }
       /* else if (this.selectAfterSalesType === 3 || this.selectAfterSalesType === 4 || this.selectAfterSalesType === 5) {
          if (!this.selectCourierCompany) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择一个物流公司';
            return;
          } else if (!this.logisticsNumber) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写物流单号';
            return;
          }
        } */
        this.orderMsgParams = {
          OrderId: this.systemOrderNum,
          ReType: this.selectAfterSalesType,
          RefundReasonId: this.selectAfterSalesReason,
          // LogisticId: this.selectCourierCompany,
          LogisticId: '',
          // ExpressNum: this.logisticsNumber,
          ExpressNum: '',
          // SendOutStoreroomId: this.selectWarehouse,
          RefundMessage: this.orderRemark,
          RefundDetailBaseInfo: []
        };
        for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
          if (this.orderMsg.OrderDetailList[i].isError && !this.orderMsg.OrderDetailList[i].errorGoodsNum && !this.orderMsg.OrderDetailList[i].errorSize) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请将错发信息填写完整';
            return;
          }
          this.orderMsgParams.RefundDetailBaseInfo.push({
            OrderDetailId: this.orderMsg.OrderDetailList[i].Id,
            Quantity: this.orderMsg.OrderDetailList[i].SendQuantity,
            OfferFee: this.orderMsg.OrderDetailList[i].OfferFee,
            IsWrongSend: this.orderMsg.OrderDetailList[i].isError,
            WrongSendGoodsId: this.orderMsg.OrderDetailList[i].errorGoodsNum,
            WrongSendSize: this.orderMsg.OrderDetailList[i].errorSize
          });
        }
        this.$axios.post(this.Global.checkExpressNumIsUsed(this.systemOrderNum), null).then((res) => {
          if (!res.data.errorMsg.length) {
            console.log(res);
            this.saveRefundInfo();
          } else {
            this.ctrlBtn('checkOrderNum', this.orderMsgParams);
          }
        });
      },

      // 提交售后申请
      saveRefundInfo() {
        if (!this.selectAfterSalesType) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个售后类型';
          return;
        } else if (!this.selectAfterSalesReason) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个售后原因';
          return;
        }
        for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
          if (this.orderMsg.OrderDetailList[i].Quantity < this.orderMsg.OrderDetailList[i].SendQuantity) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '退货数量不能大于订单明细数量';
            return;
          }
        }
       /* else if (this.selectAfterSalesType === 3 || this.selectAfterSalesType === 4 || this.selectAfterSalesType === 5) {
          if (!this.selectCourierCompany) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择一个物流公司';
            return;
          } else if (!this.logisticsNumber) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写物流单号';
            return;
          }
        } */
        this.orderMsgParams = {
          OrderId: this.systemOrderNum,
          ReType: this.selectAfterSalesType,
          RefundReasonId: this.selectAfterSalesReason,
          LogisticId: this.selectCourierCompany,
          ExpressNum: this.logisticsNumber,
          // SendOutStoreroomId: this.selectWarehouse,
          RefundMessage: this.orderRemark,
          RefundDetailBaseInfo: []
        };
        for (let i = 0; i < this.orderMsg.OrderDetailList.length; i++) {
          if (this.orderMsg.OrderDetailList[i].isError && !this.orderMsg.OrderDetailList[i].errorGoodsNum && !this.orderMsg.OrderDetailList[i].errorSize) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请将错发信息填写完整';
            return;
          }
          this.orderMsgParams.RefundDetailBaseInfo.push({
            OrderDetailId: this.orderMsg.OrderDetailList[i].Id,
            Quantity: this.orderMsg.OrderDetailList[i].SendQuantity,
            OfferFee: this.orderMsg.OrderDetailList[i].OfferFee,
            IsWrongSend: this.orderMsg.OrderDetailList[i].isError,
            WrongSendGoodsId: this.orderMsg.OrderDetailList[i].errorGoodsNum,
            WrongSendSize: this.orderMsg.OrderDetailList[i].errorSize
          });
        }
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.saveRefundInfo, this.orderMsgParams).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '操作成功,可以前往售后列表查询';
                self.getRefundCountInfo();
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 获取分销商的售后统计数据
      getRefundCountInfo() {
        this.$axios.get(this.Global.getRefundCountInfo).then((res) => {
          if (!res.data.errorMsg.length) {
            this.refundCountInfo = res.data.resData.refundCountInfo;
            this.$store.commit('refundCountInfo', this.refundCountInfo);
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsgParams = msg;
        switch (type) {
          case 'checkOrderNum':
            this.dialogTitle = '提示';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.showType === 'del' && e.handleType) {
          this.orderMsg.OrderDetailList.splice(this.orderMsgParams, 1);
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc && !this.dialogShowType) {
         /* this.$router.push({
            path: '/home/as_list'
          }); */
           this.systemOrderNum = null;
           this.selectAfterSalesType = null;
           this.selectAfterSalesReason = null;
           this.selectCourierCompany = null;
           this.logisticsNumber = null;
           this.orderRemark = null;
           this.orderMsg.StoreroomName = null;
           this.orderMsg.OrderDetailList = [];
           this.orderMsgParams.RefundDetailBaseInfo = [];
        }
      }
    },
    created() {
      this.getRefundTypeList();
      this.getRefundReasonList();
      this.getSendOutStoreroomList();
      this.getAllLogisticList();
      if (this.$route.query['orderNum']) {
        this.systemOrderNum = this.$route.query['orderNum'];
        this.getOrderData();
        console.log('跳转后的参数', this.systemOrderNum);
      }
    },
    activated() { // 只有keep-alive激活才会被使用
      if (this.$route.query['orderNum']) {
        this.systemOrderNum = this.$route.query['orderNum'];
        this.getOrderData();
      }
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.getRefundTypeList();
        this.getRefundReasonList();
        this.getSendOutStoreroomList();
        this.getAllLogisticList();
        this.isShow = false;
        this.orderMsgParams = null;
        this.systemOrderNum = null;
        this.orderRemark = null;
        this.orderMsg = {
          OutOrderId: '', // 外部/平台订单号
            OrderRefundRelationList: null, // 判断是否售后过
            OrderDetailList: [] // 商品明细列表
        };
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";

  .after_sales_apply {
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: $cfff;

    .after_sales_apply_top {
      /*height: 420px;*/
      min-height: 360px;

      .after_sales_apply_top_left {
        display: inline-block;
        width: calc(55% - 10px);
        padding-left: 10px;
        float: left;

        & > div {
          margin-top: 10px;

          &.after_sales_message {
            display: flex;
            align-items: center;

            textarea {
              max-width: 400px;
            }
          }

          i {
            color: red;
          }

          span {
            display: inline-block;
            width: 98px;
            text-align: right;
          }

          & > div {
            display: inline-block;
          }
        }
      }

      .after_sales_apply_top_right {
        display: inline-block;
        width: 37%;
        max-width: 500px;
        min-width: 410px;
        max-height: 445px;
        float: left;
        margin-top: 10px;
        margin-bottom: 10px;
        /*margin-right: 10px;*/
        /*border: 1px solid rgba(121, 121, 121, 1);*/
        box-shadow: 0 0 9px 3px #b5b4b4;
        border-radius: 7px;
        padding: 5px;

        & > div:first-child {
          text-align: center;
          padding: 10px 0;
          border-bottom: 1px solid rgba(121, 121, 121, 1);
          font-weight: bold;
          background-color: #eeeeee;
          color: red;
          font-size: 16px;
        }

        & > div:nth-child(2) {
          /*border-top: 1px solid rgba(121, 121, 121, 1);*/
          padding: 5px 2px;
        }

        p {
          text-indent: 2em;
        }
      }
    }

    .after_sales_apply_msg {
      padding: 0 5px;

      .table {
        .w60 {
          width: 60px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/after-sales-apply.vue